import { Injectable } from '@angular/core';
import { Environment } from '@libs/order-process/shared/types';
import { EnvironmentName, Version } from '@libs/shared/interfaces/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService implements Environment {
  private _environment!: Environment;
  private _version!: Version;

  constructor() {}

  get production(): boolean {
    return this._environment.production;
  }

  get envName(): EnvironmentName {
    return this._environment.envName;
  }

  get storagePrefix(): string {
    return this._environment.storagePrefix;
  }

  get apiUrl(): string {
    return this._environment.apiUrl;
  }

  get wordpressBaseUrl(): string {
    return this._environment.wordpressBaseUrl;
  }

  get languages(): string[] {
    return this._environment.languages;
  }

  get defaultLanguage(): string {
    return this._environment.defaultLanguage;
  }

  get version(): string {
    return this._version.version;
  }

  get buildNumber(): string {
    return this._version.buildNumber;
  }

  get versionString(): string {
    return `${this._version.version} (${this._version.buildNumber})`;
  }

  public init(environment: Environment, version: Version): void {
    this._environment = environment;
    this._version = version;
  }
}
